import { Controller } from "@hotwired/stimulus";

// Replaces SearchfieldWidget#updateSearchtype (searchfield_widget.ts),
// gated off for rebuilt pages along with the rest of Searchfield.load().
// Switching between Tur & Retur / Enkel / Multi-City is server-rendered
// (ApplicationController#load_form renders the right
// common/searchfield/search_field_* partial for the requested type as a
// plain HTML fragment, no layout) rather than a client-side template swap,
// so this fetches and replaces the container's content rather than
// reimplementing the return/oneway/multi markup in JS. Stimulus's own
// MutationObserver picks up and connects the autocomplete/datepicker/etc.
// controllers nested in the newly inserted HTML automatically -- no manual
// re-connect needed.
export default class extends Controller {
  static targets = ["container"];

  switch(event) {
    const value = event.target.value;
    const href = event.target.dataset.href;
    if (this.containerTarget.dataset.view === value) return;

    fetch(`/load_form/${value}`, { headers: { Accept: "text/html" } })
      .then((response) => response.text())
      .then((html) => {
        this.containerTarget.innerHTML = html;
        this.containerTarget.dataset.view = value;
        if (href && window.location.pathname.split("/").length === 2) {
          history.pushState(null, null, href);
        }
      });
  }
}
